import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { bsClass, getClassSet, splitBsProps } from './utils/bootstrapUtils';
import createChainedFunction from './utils/createChainedFunction';
import CloseButton from './CloseButton';
class ModalHeader extends React.Component {
  render() {
    const {
      closeLabel,
      closeButton,
      onHide,
      className,
      children,
      ...props
    } = this.props;
    const modal = this.context.$bs_modal;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = getClassSet(bsProps);
    return /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }), closeButton && /*#__PURE__*/_jsx(CloseButton, {
      label: closeLabel,
      onClick: createChainedFunction(modal && modal.onHide, onHide)
    }), children);
  }
}

// TODO: `aria-label` should be `closeLabel`.

ModalHeader.defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
ModalHeader.contextTypes = {
  $bs_modal: PropTypes.shape({
    onHide: PropTypes.func
  })
};
export default bsClass('modal-header', ModalHeader);